import { Module } from 'vuex';
import { IRootState } from './store';

export interface IAppState {
  initialized: boolean;
  shareHasMembers: boolean;
  loading: boolean;
  snackBar: ISnackBar;
}

let initShareHasMembers = false;
// Development setting
if (process.env.NODE_ENV === 'development' || document.location.host.indexOf('localhost') > -1) {
  initShareHasMembers = true;
}
// Production setting
if (document.location.host.indexOf('vantaantaksi') > -1) {
  initShareHasMembers = false;
} else if (document.location.host.indexOf('kirjaclub') > -1) {
  initShareHasMembers = true;
} else if (document.location.host.indexOf('kc-regit') > -1) {
  initShareHasMembers = true;
} else if (document.location.host.indexOf('kc.8p') > -1) {
  initShareHasMembers = true;
} else if (document.location.host.indexOf('kirja') > -1) {
  initShareHasMembers = true;
}

const appState: IAppState = {
  initialized: false,
  shareHasMembers: initShareHasMembers,
  loading: false,
  snackBar: {
    show: false,
    text: '',
    color: 'info',
    timeout: 0,
  },
};

const appGetters = {
  shareHasMembers: (state: IAppState) => {
    return state.shareHasMembers;
  },
};

const appMutations = {
  setInitialized: (state: IAppState, initialized: boolean) => state.initialized = initialized,
  setShareHasMembers: (state: IAppState, hasMembers: boolean) => state.shareHasMembers = hasMembers,
  setLoading: (state: IAppState, isLoading: boolean) => state.loading = isLoading,
  setSnackBar: (state: IAppState, snackBar: ISnackBar) => state.snackBar = snackBar,
  setSnackBarShow: (state: IAppState, show: boolean) => state.snackBar.show = show,
  setSnackBarColor: (state: IAppState, color: string) => state.snackBar.color = color,
  setSnackBarText: (state: IAppState, text: string) => state.snackBar.text = text,
  setSnackBarTimeout: (state: IAppState, timeout: number) => state.snackBar.timeout = timeout,
};

const appActions = {
  async initializeApp({ dispatch, commit, rootState }: { dispatch: any, commit: any, rootState: IRootState }) {
    commit('setLoading', true);
    commit('setInitialized', false);
    await dispatch('auth/getProfile', null, { root: true });
    if (rootState.auth.profile) {
      await dispatch('initializeStores');
    }
    commit('setInitialized', true);
    commit('setLoading', false);
  },
  async initializeStores({ dispatch, commit, rootState }: { dispatch: any, commit: any, rootState: IRootState }) {
    if (rootState.auth.profile) {

      await dispatch('admin/getShares', null, { root: true });

      if (rootState.auth.profile.isAdmin) {
        await dispatch('admin/getUsers', null, { root: true });
      }
      if (rootState.app.shareHasMembers) {
        await dispatch('user/getProfiles', null, { root: true });
        await dispatch('user/getUserProfile', null, { root: true });
        await dispatch('group/getGroups', null, { root: true });
        await dispatch('group/getAllGroupUserProfiles', null, { root: true });
      }
    }
  }
};

const appStore: Module<IAppState, IRootState> = {
  namespaced: true,
  state: appState,
  getters: appGetters,
  mutations: appMutations,
  actions: appActions,
};
export default appStore;
